// extracted by mini-css-extract-plugin
export default {"container":"vrAcademic_container__NK40K","text":"vrAcademic_text__iT63z","content":"vrAcademic_content__aO2KI","image":"vrAcademic_image__OAjxj","video":"vrAcademic_video__ety+v"};